var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F6FAFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.16 22C49.8144 21.4012 49.3196 20.9023 48.7237 20.5517C48.1278 20.2012 47.4512 20.0111 46.76 20H21.16L20 15.48C19.8828 15.0437 19.6213 14.6599 19.2582 14.3911C18.895 14.1224 18.4515 13.9845 18 14H14C13.4696 14 12.9609 14.2107 12.5858 14.5858C12.2107 14.9609 12 15.4696 12 16C12 16.5304 12.2107 17.0391 12.5858 17.4142C12.9609 17.7893 13.4696 18 14 18H16.48L22 38.52C22.1172 38.9563 22.3787 39.3401 22.7418 39.6089C23.105 39.8776 23.5485 40.0155 24 40H42C42.3693 39.9989 42.7311 39.8955 43.0453 39.7014C43.3595 39.5072 43.6138 39.2298 43.78 38.9L50.34 25.78C50.6243 25.184 50.7567 24.5269 50.7253 23.8674C50.6939 23.2078 50.4997 22.5663 50.16 22Z",
    fill: "#A6B4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50C24.6569 50 26 48.6569 26 47C26 45.3431 24.6569 44 23 44C21.3431 44 20 45.3431 20 47C20 48.6569 21.3431 50 23 50Z",
    fill: "#A6B4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50C44.6569 50 46 48.6569 46 47C46 45.3431 44.6569 44 43 44C41.3431 44 40 45.3431 40 47C40 48.6569 41.3431 50 43 50Z",
    fill: "#A6B4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.33dcfcda0b0d1f7d00443b58c8de28c8.svg";
export { ForwardRef as ReactComponent };